<template>
  <div>
    <flat-pickr
      :id="context.id"
      v-model="date"
      :config="datePickerConfig"
      :disabled="isDisabled"
      class="timeNoBackground w-100"
      @input="onChange"
    />
  </div>
</template>

<script>
import { ref, onMounted, watch } from "@vue/composition-api";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    flatPickr,
  },
  props: {
    id: String,
    name: String,
    label: String,
    fieldOptions: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    context: Object
  },
  setup(props, { emit }) {
    const defaultFormat = "d/m/Y"
    const format = props.fieldOptions.fieldTypeCfg.data[0]?.format?.value || defaultFormat
    const datePickerConfig = {
      dateFormat: format,
      allowInput: true,
      locale: {
        firstDayOfWeek: 1,
      },
    };
    const date = ref('');
    const isDisabled = ref(false);
    onMounted(() => {
      isDisabled.value = props.context.attributes.disabled ?? false;
      if(props.context.model) {
        date.value = normalizeDate(props.context.model, format)
        return;
      }
      const d = new Date();
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      const showEmpty = props.fieldOptions.fieldTypeCfg.data[0]?.showEmpty

      setTimeout(() => {
        date.value = showEmpty ? '' : normalizeDate(`${day}/${month}/${year}`, format)
        onChange()
      }, 2000)      
      
    });

    watch(
      () => props.context.attributes.disabled,
      (newValue, oldValue) => {
        isDisabled.value = props.context.attributes.disabled ?? false;
      },
      { immediate: true }
    );

    watch(
      () => props.context.model,
      (newValue, oldValue) => {
        if(newValue) {
          setDate(newValue)
        }
      },
      { immediate: true }
    );

    function setDate(value) {
      date.value = value
    }

    async function onChange() {
      props.context.model = date.value
    }

    function normalizeDate(input, format) {
      if (!input) return "";
      const pad2 = n => String(n).padStart(2, "0");
      let day, month, year;
      // format "2025-11-12"
      let iso = input.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (iso) {
        year = parseInt(iso[1], 10);
        month = parseInt(iso[2], 10);
        day = parseInt(iso[3], 10);
      } else {
        // formats: "20/12/25", "20-12-2025"
        let m = input.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2}|\d{4})$/);
        if (!m) return "";

        day = parseInt(m[1], 10);
        month = parseInt(m[2], 10);
        year = parseInt(m[3], 10);

        if (m[3].length === 2) {
          year = 2000 + year;
        }
      }

      if (!(day >= 1 && day <= 31 && month >= 1 && month <= 12)) return "";

      const tokens = {
        d: pad2(day),
        m: pad2(month),
        y: String(year).slice(-2),
        Y: String(year)
      };

      return format.replace(/d|m|y|Y/g, t => tokens[t]);
    }

    return {
      isDisabled,
      date,
      datePickerConfig,
      onChange
    }
  }
}
</script>
<style lang="scss" scoped>
.timeNoBackground {
  border-radius: 0.3em;
  background-color: transparent;
  margin: 0;
  border-radius: 0.3em;
  border: 1px solid #cecece;
  background-color: transparent;
  padding: 0.75em;
  margin: 0;
}
.dark-layout {
  .timeNoBackground {
    background-color: var(--second-dark) !important;
    color: #fff;
  }
}
</style>